import { __decorate } from 'tslib';
import { property } from 'lit/decorators.js';
import SgdsElement from './sgds-element.js';

class CardElement extends SgdsElement {
}
CardElement.styles = SgdsElement.styles;
__decorate([
    property()
], CardElement.prototype, "borderColor", void 0);
__decorate([
    property()
], CardElement.prototype, "bgColor", void 0);
__decorate([
    property()
], CardElement.prototype, "textColor", void 0);

export { CardElement };
//# sourceMappingURL=card-element.js.map
